import VehicleSectionChargeValue from './VehicleSectionChargeValue';

export default VehicleSectionChargeValue;
